import React from 'react';
import { FormGroup } from 'react-bootstrap';
import { Form, Validator } from '../widgets';

const EquipmentDropdown = props => (
    <Form.Cell>
        <FormGroup>
            <Validator validation={props.validation}>
                <Form.Label>{props.name}{props.required ? <Validator.Mand /> : <></>}</Form.Label>
                <Form.Select
                    id={'cmb' + props.id}
                    name={props.key_name}
                    className="select-control-sm"
                    value={props.value}
                    onChange={(e) => { props.onChange(e, props.key_name); }}
                    placeholder="Select"
                    options={props.values}
                    sortType="asc" 
                    {...props.selectProps}
                    classNamePrefix={`${props.required ? 'form_select_create' : ''} react-select_option`}
                >
                </Form.Select>
                {props.required ? <Validator.Text /> : <></>}
            </Validator>
        </FormGroup>
    </Form.Cell>
);

export default EquipmentDropdown;